import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {UploaderComponent} from '../../shared/uploader/uploader.component';
import {NzMessageService, NzModalService} from 'ng-zorro-antd';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {combineLatest, Subject} from 'rxjs';
import {DocumentsService} from 'src/app/services/business/documents/documents.service';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import { BusinessInfoService } from 'src/app/services/business/business-info/business-info.service';
import {RootService} from 'src/app/services/root.service';
import { capitalizeFirstLetter, removeAllSpacingBetweenWords } from 'src/app/helpers';
import {UploadService} from '../../services';
import {getDateHelper} from '../../shared/common/helper';
import {DOC_PRODUCT_TYPE} from '../../helpers/constant';

@Component({
  selector: 'app-business-info',
  templateUrl: './business-info.component.html',
  styleUrls: ['./business-info.component.scss']
})
export class BusinessInfoComponent implements OnInit {
  loading;
  total;
  info = true;
  title;
  // tslint:disable-next-line:variable-name
  expire_at;
  expired;
  page = 1;
  // tslint:disable-next-line:variable-name
  page_size = 10;
  query;
  addressDisplay;
  changeAction;
  documents = [];
  // tslint:disable-next-line:variable-name
  form = this.fb.group({
    businessName: ['', Validators.required],
    displayName: '',
    taxCode: ['', Validators.required],
    address: ['', Validators.required],
    provinceId: ['', Validators.required],
    districtId: ['', Validators.required],
    phone: ['', [Validators.required, Validators.pattern('[0-9]*')]],
    email: ['', [Validators.required, Validators.pattern('^[a-z0-9_\\.]{1,32}@[a-z0-9]{2,}(\\.[a-z0-9]{2,4}){1,2}$')]],
    website: [''],
    avatar: '',
    cover: '',
    description: [''],
    addressNewName: [null, Validators.required],
    provinceNewId: [null, Validators.required],
    addressNew: [true, Validators.required],
  });
  DOC_PRODUCT_TYPE = DOC_PRODUCT_TYPE;
  cities = [];
  districts = [];
  cityNew: any = [];
  listWard: any = [];
  avatar: any[] = [];
  cover: any[] = [];
  // tslint:disable-next-line:variable-name
  list_id = [];
  unsubscribe$ = new Subject<void>();
  // @ts-ignore
  @ViewChild('delete') delete;
  // @ts-ignore
  @ViewChild('create') create;
  // @ts-ignore
  @ViewChild('addDocument') addDocument;
  // multiple checkbox
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  mapOfCheckedId = {};
  constructor(
    private  fb: FormBuilder,
    private modalService: NzModalService,
    private docService: DocumentsService,
    private notification: NzNotificationService,
    private  businessInfoService: BusinessInfoService,
    private rootService: RootService,
    private uploadService: UploadService,
    private modal: NzModalService,
   ) {
  }

  ngOnInit(): void {
    this.getCities();
    this.getInfoBusiness();
    this.notification.config({
      nzPlacement: 'bottomRight'
    });

    this.rootService.getLocationNew({
      type: 1
    }).subscribe((res) => {
      this.cityNew = res.data.data;
    });

    this.form.get('provinceNewId').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      console.log('val_kkk', val);
      if (val) {
        this.rootService.getLocationNew({
          type: 2,
          parentId: val
        }).subscribe((res: any) => {
          if (res.code === 1) {
            this.listWard = res && res.data && res.data.data ?  res.data.data : [];
          }
        });
      }
    });
    combineLatest([
      this.form.get('provinceId').valueChanges,
      this.form.get('districtId').valueChanges,
      this.form.get('address').valueChanges,
    ])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([provinceId, districtId, address]) => {
        if (provinceId && districtId && address) {
          const query = {
            type: 1,
            parentId: 0,
            cityOldId: provinceId,
            // wardOldId: districtId
          };
          this.rootService.getLocationOld(query).subscribe(res => {
            // console.log("res", res)
            if (res.code === 1 && res.data && res.data.cityNew && res.data.cityNew.name) {
              this.addressDisplay = [address, res.data.cityNew.name].join(', ');
            }
          });
        } else {
          this.addressDisplay = '';
        }
      });
  }
  getCities() {
    const response = this.rootService.listCities();
    response.subscribe(
      res => {
        this.cities = res.data.items;
      },
      error => {
        this.cities = [];
      }
    );
  }
  getDistricts(event) {
    // tslint:disable-next-line:variable-name
    const district_id = this.form.get('districtId').value;
    if (district_id) {
      this.form.get('districtId').setValue('');
    }
    // tslint:disable-next-line:variable-name
    const province_id = event;
    if (province_id) {
      const response = this.rootService.listDistricts(province_id);
      response.subscribe(
        res => {
          this.districts = res.data.items;
        },
        error => {
          this.districts = [];
        }
      );
    }
  }
  // ========e thong tin doanh nghiep========
  getInfoBusiness() {
    this.businessInfoService.getInfoBusiness().subscribe(
      res => {
        if (res.code === 1) {
          const data = res.data;
          // this.getDistricts(data.provinceId);
          this.form.get('businessName').setValue(data.businessName);
          if (data.businessName != null) {
            this.form.controls.businessName.disable();
          }
          this.form.get('displayName').setValue(data.displayName);
          this.form.get('taxCode').setValue(data.taxCode);
          if (data.taxCode != null) {
            this.form.controls.taxCode.disable();
          }
          this.form.get('address').setValue(data.address);
          this.form.get('provinceId').setValue(data.provinceId);
          if (data.provinceId) {
            console.log("tuan nguyen hung")
            this.getDistricts(data.provinceId);
          }
          this.form.get('districtId').setValue(data.districtId);
          this.form.get('phone').setValue(data.phone);
          this.form.get('email').setValue(data.email);
          this.form.get('website').setValue(data.website);
          this.form.get('description').setValue(data.description);
          this.form.get('addressNew').setValue(data.addressNew);
          this.form.get('addressNewName').setValue(data.addressNewName);
          this.form.get('provinceNewId').setValue(data.provinceNewId);
          if (data.avatar) {
            const avatar = {
              name: data.avatar,
              type: 'jpeg',
              url: data.avatar,
            };
            this.avatar.push(avatar);
          }
          if (data.cover) {
            const cover = {
              name: data.cover,
              type: 'jpeg',
              url: data.cover,
            };
            this.cover.push(cover);
          }
        } else {
          this.notification.create(
            'error',
            'Lấy thông tin doanh nghiệp thất bại',
            res.message
          );
        }
      },
      error => {
        this.notification.create(
          'error',
          'Lấy thông tin doanh nghiệp thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }
  updateInfoBusiness() {
    if (this.avatar.length) {
      this.avatar.map(item => {
        this.form.get('avatar').setValue(item.url);
      });
    }
    if (this.cover.length) {
      this.cover.map(item => {
        this.form.get('cover').setValue(item.url);
      });
    }

    if (this.form.get('addressNew').value) {
      this.form.get('addressNewName').setValidators([Validators.required, Validators.maxLength(255)]);
      this.form.get('provinceNewId').setValidators([Validators.required]);

      this.form.get('provinceId').clearValidators();
      this.form.get('districtId').clearValidators();
      this.form.get('address').clearValidators();
    } else {
      this.form.get('address').setValidators([Validators.required, Validators.maxLength(255)]);
      this.form.get('provinceId').setValidators([Validators.required]);
      this.form.get('districtId').setValidators([Validators.required]);

      this.form.get('addressNewName').clearValidators();
      this.form.get('provinceNewId').clearValidators();
    }
    this.form.get('provinceId').updateValueAndValidity();
    this.form.get('districtId').updateValueAndValidity();
    this.form.get('address').updateValueAndValidity();
    this.form.get('addressNewName').updateValueAndValidity();
    this.form.get('provinceNewId').updateValueAndValidity();
    // tslint:disable-next-line:forin
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.invalid) {
      return;
    }
    const  businessName$ =  this.form.get('businessName').value ? this.form.get('businessName').value.trim() : '';
    const  taxCode$ =  this.form.get('taxCode').value ? this.form.get('taxCode').value.trim() : '';
    const  nameDisplay$ =  this.form.get('displayName').value ? this.form.get('displayName').value.trim() : '';
    const  address$ =  this.form.get('address').value ? this.form.get('address').value.trim() : '';
    const  provinceId$ =  this.form.get('provinceId').value;
    const  districtId$ =  this.form.get('districtId').value;
    const  phone$ =  this.form.get('phone').value ? this.form.get('phone').value.trim() : '';
    const  email$ =  this.form.get('email').value ? this.form.get('email').value.trim() : '';
    const  website$ =  this.form.get('website').value ? this.form.get('website').value.trim() : '';
    let avatar$ = '';
    if (this.avatar.length > 0) {
      this.avatar.map(item => {
        avatar$ = item.url;
      });
    }
    let cover$ = '';
    if (this.cover.length > 0) {
      this.cover.map(item => {
        cover$ = item.url;
      });
    }
    const  description$ =  this.form.get('description').value ? this.form.get('description').value.trim() : '';
    const  addressNewName =  this.form.get('addressNewName').value ? this.form.get('addressNewName').value.trim() : '';

    const body = {
      businessName: businessName$,
      taxCode: taxCode$,
      nameDisplay: nameDisplay$,
      address: address$,
      provinceId: provinceId$,
      districtId: districtId$,
      phone: phone$,
      email: email$,
      website: website$,
      description: description$,
      avatar: avatar$,
      cover: cover$,
      addressNew: this.form.get('addressNew').value,
      addressNewName,
      provinceNewId: this.form.get('provinceNewId').value,
    };
    if (body.addressNew) {
      body.provinceId = null;
      body.districtId = null;
      body.address = null;
    } else {
      body.provinceNewId = null;
      body.addressNewName = null;
    }
    this.loading = true;
    this.businessInfoService.updateInfoBusiness(body).subscribe(
      res => {
        this.loading = false;
        if (res.code === 1) {
          this.notification.create(
            'success',
            'Thành công',
            'Cập nhập thông tin doanh nghiệp thành công'
          );
          // this.businessInfoService.changeName(nameDisplay$);
        } else {
          this.notification.create(
            'error',
            'Cập nhập thông tin doanh nghiệp thất bại',
            res.message
          );
        }
      },
      error => {
        this.loading = false;
        this.notification.create(
          'error',
          'Cập nhập thông tin doanh nghiệp thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }
// ==========end thong tin doanh nghiep===========//
  showDocuments() {
    this.info = false;
    this.loadData();
  }

  // =============giay to================//
  loadData() {
    this.loading = true;
    this.query = {
      title: this.title ? this.title.trim() : '',
      expire_at: this.expire_at ? this.getDate(this.expire_at) : '',
      page: this.page,
      page_size: this.page_size
    };
    if (this.expired) {
      this.query.expired = this.expired;
    }
    this.docService.list(this.query).subscribe(
      res => {
        if (res.code === 1) {
          if (res.data.items && res.data.items.length === 0 && this.page > 1) {
            this.page = this.page - 1;
            this.loadData();
            return;
          }
          this.documents = res.data.items;
          this.loading = false;
          this.total = res.data.totalElement;
          this.refreshStatus();
        } else {
          this.notification.create(
            'error',
            'Lấy danh sách giấy tờ thất bại',
            res.message
          );
        }
      },
      error => {
        this.loading = false;
        this.notification.create(
          'error',
          'Lấy danh sách giấy tờ thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  getDate(date) {
    return getDateHelper(date);
  }

  search() {
    this.page = 1;
    this.loadData();
  }

  reset() {
    this.page = 1;
    this.title = undefined;
    this.expired = undefined;
    this.expire_at = undefined;
    this.mapOfCheckedId = {};
    this.list_id = [];
    this.loadData();
  }

  createDocument(event) {
    event.title = capitalizeFirstLetter(removeAllSpacingBetweenWords(event.title));
    this.docService.create(event).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.notification.create(
            'success',
            'Thành công',
            'Thêm giấy tờ thành công'
          );
          this.create.hide();
          this.page = 1;
          this.loadData();
        } else {
          this.create.success();
          this.notification.create(
            'error',
            'Thêm giấy tờ thất bại',
            res.message
          );
        }
      },
      error => {
        this.create.success();
        this.notification.create(
          'error',
          'Thêm giấy tờ thất bại',
          'Có lỗi xảy ra'
        );
      }
    );
  }

  updateDocument(event) {
    this.loadData();
  }
  multipleDelete() {
    this.delete.show(this.list_id);
  }
  // checkbox multiple
  checkAll(value: boolean) {
    this.documents.forEach(item => (this.mapOfCheckedId[item.id] = value));
    this.refreshStatus();
  }

  refreshStatus() {
    if (this.documents.length > 0) {
      this.isAllDisplayDataChecked = this.documents.every(item => this.mapOfCheckedId[item.id]);
    } else {
      this.isAllDisplayDataChecked = false;
    }
    this.isIndeterminate = this.documents.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;
    for (const key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
  }
  deleteDocument(ids) {
    const body = {
      body: {
        listDocumentId: ids
      }
    };
    this.docService.remove(body).subscribe(
      res => {
        if (res.code === 1) {
          this.mapOfCheckedId = {};
          this.list_id = [];
          this.changeAction = undefined;
          this.notification.create(
            'success',
            'Thành công',
            'Xoá giấy tờ thành công'
          );
          this.delete.cancel();
          setTimeout(() => {
            this.loadData();
          }, 1000);
        } else {
          this.notification.create(
            'error',
            'Xoá giấy tờ thất bại',
            res.message
          );
        }
        this.delete.success();
      },
      error => {
        this.delete.success();
        this.notification.create(
          'error',
          'Xoá giấy tờ thất bại',
          'Có lỗi xảy ra'
        );
      }
    );
  }
// ===============end giay to==============//

  cancel() {
    this.avatar = [];
    this.cover = [];
    this.getInfoBusiness();
  }

  submit() {
    // tslint:disable-next-line:radix
    if (parseInt(this.changeAction) === 1) {
      this.multipleDelete();
    }
  }

  // upload file
  openUploadDialog(field: string) {
    const fileType = 'jpg,jpeg,png,gif,bmp';
    const modal = this.modal.create({
      nzTitle: `Tải ảnh lên`,
      nzContent: UploaderComponent,
      nzFooter: null,
      nzComponentParams: {
        fileExt: fileType,
        multiple: true,
      },
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe((changeParam) => {
        console.log('123123', changeParam);
        if (changeParam.type === 'success') {
          if (field === 'avatar' || field === 'cover') {
            this[field] = [{ url: changeParam.file.response.url }];
            this.form
                .get(field)
                .setValue(this.avatar[0].url);
            // }
          }

        }
      });
      modal
        .getContentComponent()
        .done.pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          modal.close();
        });
    });
  }

  onRemoveFile(field: string, index: number) {
    this[field].splice(index, 1);
  }
  showModalAddDocumentToProduct() {
    this.addDocument.showModal();
  }
  handleAddDocument(event) {
    const listProductId = event.data;
    const listDocumentId = this.list_id;
    // console.log(listProductId, listDocumentId);
    const body = {
      listDocumentId,
      listProductId,
      docProductType: event.docProductType
    };
    this.businessInfoService.addDocumentToProduct(body).subscribe(
      res => {
        this.addDocument.cancelLoadingBtn();
        if (res.code === 1) {
          this.notification.success(
            'Thành công',
            'Thêm giấy tờ cho sản phẩm thành công'
          );
          this.addDocument.cancelModal();
          return;
        }
        this.notification.error(
          'Có lỗi xảy ra',
          res.message
        );
      },
      error => {
        this.addDocument.cancelLoadingBtn();
        this.notification.error(
          'Có lỗi xảy ra',
          error.message
        );
      }
    );
  }
}
